export function initPopularAtc(): void {
  document.addEventListener('submit', (evt) => {
    const form = (evt.target as HTMLElement).closest<HTMLFormElement>('.popular-content form');
    if (!form) return;

    evt.preventDefault();
    evt.stopPropagation();

    const submitBtn = form.querySelector<HTMLButtonElement>('[type="submit"]');
    const spinner = form.querySelector<HTMLElement>('.loading-overlay__spinner');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('loading');
    }
    spinner?.classList.remove('hidden');

    const cart = document.querySelector<HTMLElement>('cart-drawer') || document.querySelector<HTMLElement>('cart-notification');
    const fetchConfigFn = window.fetchConfig;
    if (!fetchConfigFn) return;

    const config = fetchConfigFn('javascript');
    (config.headers as Record<string, string>)['X-Requested-With'] = 'XMLHttpRequest';
    (config.headers as Record<string, string>)['Accept'] = 'application/json';
    delete (config.headers as Record<string, string>)['Content-Type'];

    const formData = new FormData(form);

    if (cart) {
      const sectionsToRender = (cart as any).getSectionsToRender?.() ?? [
        { section: 'cart-drawer-optimized-v2', selector: '.drawer__inner' },
      ];
      formData.append('sections', sectionsToRender.map((s: any) => s.section ?? s.id));
      formData.append('sections_url', window.location.pathname);
      (cart as any).setActiveElement?.(document.activeElement);
    }

    (config as any).body = formData;

    const cartAddUrl = window.routes?.cart_add_url;
    if (!cartAddUrl) return;

    fetch(cartAddUrl, config as any)
      .then(async (res) => {
        const contentType = res.headers.get('content-type') ?? '';
        if (!res.ok || !contentType.includes('application/json')) throw new Error('popular-atc: cart add did not return JSON');
        return res.json();
      })
      .then((response) => {
        if (response.status) {
          console.error('[popular-atc] cart error:', response.description);
          return;
        }

        if (!cart) {
          const cartUrl = window.routes?.cart_url;
          if (cartUrl) window.location = cartUrl as any;
          return;
        }

        window.publish?.(window.PUB_SUB_EVENTS?.cartUpdate as string, {
          source: 'popular-atc',
          cartData: response,
        });

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        customElements.whenDefined(cart.tagName.toLowerCase()).then(() => {
          (cart as any).renderContents?.(response);
        });
      })
      .catch((e) => console.error('[popular-atc] error:', e))
      .finally(() => {
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
        }
        spinner?.classList.add('hidden');
      });
  });
}
